import AdditionalTicketInformationList, { AdditionalTicketInformationListProps } from './AdditionalTicketInformationList';

export type { AdditionalTicketInformationListProps };
export default AdditionalTicketInformationList;
